var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolygonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 42,
    r: 42,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1118_149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.0896 33.3975C54.1701 32.8721 52.9881 32.8721 51.9373 33.3975L44.5821 37.7318L39.591 40.49L32.3672 44.8244C31.4478 45.3497 30.2657 45.3497 29.2149 44.8244L23.5672 41.4094C22.6478 40.8841 21.991 39.8333 21.991 38.6512V32.0841C21.991 31.0333 22.5164 29.9826 23.5672 29.3259L29.2149 26.0423C30.1343 25.5169 31.3164 25.5169 32.3672 26.0423L38.0149 29.4572C38.9343 29.9826 39.591 31.0333 39.591 32.2154V36.5497L44.5821 33.6602V29.1945C44.5821 28.1438 44.0567 27.093 43.006 26.4363L32.4985 20.2632C31.5791 19.7378 30.397 19.7378 29.3463 20.2632L18.5761 26.5676C17.5254 27.093 17 28.1438 17 29.1945V41.5408C17 42.5915 17.5254 43.6423 18.5761 44.299L29.2149 50.4721C30.1343 50.9975 31.3164 50.9975 32.3672 50.4721L39.591 46.2691L44.5821 43.3796L51.806 39.1766C52.7254 38.6512 53.9075 38.6512 54.9582 39.1766L60.606 42.4602C61.5254 42.9856 62.1821 44.0363 62.1821 45.2184V51.7856C62.1821 52.8363 61.6567 53.8871 60.606 54.5438L55.0896 57.8273C54.1701 58.3527 52.9881 58.3527 51.9373 57.8273L46.2896 54.5438C45.3701 54.0184 44.7134 52.9676 44.7134 51.7856V47.5826L39.7224 50.4721V54.8065C39.7224 55.8572 40.2478 56.9079 41.2985 57.5647L51.9373 63.7378C52.8567 64.2632 54.0388 64.2632 55.0896 63.7378L65.7284 57.5647C66.6478 57.0393 67.3045 55.9885 67.3045 54.8065V42.3288C67.3045 41.2781 66.7791 40.2273 65.7284 39.5706L55.0896 33.3975Z",
    fill: "#8247E5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1118_149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50.4358,
    height: 44,
    fill: "white",
    transform: "translate(17 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygonIcon);
export default __webpack_public_path__ + "static/media/polygon-icon.747b9f3cc5c6d745054ed04e021435ec.svg";
export { ForwardRef as ReactComponent };